module.exports = {
      id: "logo-small-usage",
      viewBox: "0 0 350 51",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }